export default class Event {

  constructor() {
    this._listeners = [];
  }

  add(listener) {
    if (!listener) {
      console.error('listener is undefind');
      console.trace();
      return;
    }
    this._listeners.push(listener);
    return listener;
  };

  remove(listener) {
    this._listeners.splice(this._listeners.indexOf(listener), 1);
  };

  removeAll() {
    this._listeners = [];
  }

  call(...args) {
    for (let i = 0; i < this._listeners.length; i++) {
      this._listeners[i](...args);
    }
  }
};
